import { CoreSonarObjectsOptimisticChangeName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { defaultSonarObjectsOptimisticChangeState } from './state';

export const coreSonarObjectsOptimisticChangeRemoveSlice = createRemoveSyncSlice({
	name: CoreSonarObjectsOptimisticChangeName,
	state: defaultSonarObjectsOptimisticChangeState,
	transform: () => defaultSonarObjectsOptimisticChangeState.data
});
